let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6yhOI")).then(() => parcelRequire('9ubgT'));